var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "9yap4staha"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.584314 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "8iqqfnga3b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.584314 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M23.87 6.81L12.307.068c-.152-.09-.342-.09-.496 0L.248 6.81C.093 6.9 0 7.067 0 7.245v13.49c0 .18.093.346.248.436l11.562 6.745c.077.044.162.066.248.066.084 0 .174-.022.248-.066l11.565-6.745c.152-.09.244-.256.244-.435V7.245c0-.181-.092-.344-.244-.435zM4.833 5.296l10.57 6.166-3.343 1.948L1.492 7.246l3.34-1.95zm2.883-1.684l10.57 6.166-1.885 1.103L5.83 4.715l1.885-1.103zm9.182 8.139l1.885-1.101v3.687l-.94-.005c-.142 0-.283.062-.377.172l-.568.667v-3.42zm-4.84-10.667l10.57 6.161-.497.289-2.85 1.664L8.714 3.032l3.344-1.948zM.996 8.114l10.565 6.167v12.33L.995 20.445V8.115zm22.129 12.331l-10.57 6.166v-12.33l3.347-1.95v4.184c0 .213.13.401.323.47.056.023.115.032.175.032.014 0 .02-.016.04-.02.126-.011.248-.052.335-.152l1.291-1.51 1.214.005c.133 0 .26-.056.352-.15.096-.094.145-.22.145-.353v-4.768l3.347-1.954v12.33z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box.8f813f79.svg";
export { ForwardRef as ReactComponent };